export default "__VITE_ASSET__Dp7PNlrv__"